import { useEffect, useState } from 'react';
import { getAdvertiserPlatformAgreement } from '../services/getAdvertiserPlatformAgreement';

export function usePlatformAdvertisingAgreement(amountUsd, options = {}) {
    const [doc, setDoc] = useState(null);
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);

        getAdvertiserPlatformAgreement(amountUsd, options)
            .then((res) => {
                if (cancelled) return;
                if (res.data?.success) {
                    setDoc({
                        title: res.data.title,
                        body: res.data.body,
                        version: res.data.version,
                        updatedAt: res.data.updatedAt,
                        esignNotice: res.data.esignNotice || null,
                        amountUsd: res.data.amountUsd,
                        screenCount: res.data.screenCount,
                        playsPerScreen: res.data.playsPerScreen,
                        guaranteedPlays: res.data.guaranteedPlays,
                        maxReviewHours: res.data.maxReviewHours,
                    });
                    setSections(Array.isArray(res.data.sections) ? res.data.sections : []);
                } else {
                    setError('Failed to load agreement');
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setError('Failed to load agreement');
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [amountUsd, options.screenCount, options.fleetSize, options.selectedScreenIds?.join(',')]);

    return { doc, sections, loading, error };
}
